__turbopack_context__.v({
  "mobileStoreBadgesWrapper": "simpleFooter-module-scss-module__NOLlUW__mobileStoreBadgesWrapper",
  "primaryLinksWrapper": "simpleFooter-module-scss-module__NOLlUW__primaryLinksWrapper",
  "socialMediaIcons": "simpleFooter-module-scss-module__NOLlUW__socialMediaIcons",
});
